var map = {
	"./FindingData-small.png": "5d09",
	"./Mapping-small.png": "fb31",
	"./Overview-small.png": "dd04",
	"./Policies-small.png": "9d34",
	"./Stories-small.png": "4f69",
	"./Strategies-small.png": "dcb9",
	"./UsingData-small.png": "45fb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c913";